import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import resultTextRaw from '../assets/result-text-ko.json';
import icon from '../assets/testresult.svg';

// ---- 타입 정의 ----
type Scores = { O: number; C: number; E: number; A: number; N: number };

type BigFiveResultState = {
  results: {
    scores: Scores;
    facetScores: Record<string, number>;
  };
};

type Level = 'low' | 'neutral' | 'high';

type DomainResult = {
  score: Level; // 'low' | 'neutral' | 'high'
  text: string;
};

type DomainBlock = {
  domain: keyof Scores; // 'O' | 'C' | 'E' | 'A' | 'N'
  title: string;
  shortDescription: string;
  results: DomainResult[];
};

// JSON 타입 캐스팅 (CRA/TS 기본 설정이면 JSON import는 any로 들어옴)
const resultText = resultTextRaw as DomainBlock[];

const BigFiveTestResultPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as BigFiveResultState | null;

  if (!state?.results) {
    // 새로고침/직접 접근 시 state가 비어있을 수 있음
    return (
      <div className="big-five-test-result-page">
        <p>결과를 불러오는데 실패했습니다.</p>
        <button onClick={() => navigate(-1)}>이전으로</button>
      </div>
    );
  }

  const { scores } = state.results;

  const getScoreLevel = (score: number): Level => {
    if (score <= 56) return 'low';
    if (score <= 88) return 'neutral';
    return 'high';
  };

  return (
    <div className="big-five-test-result-page">
      <div className="page-header">
        <img src={icon} alt="Mind Thermometer Icon" className="page-header__icon" />
        <h2 className="page-header__title">검사 결과</h2>
        <p className="page-header__subtitle">
          다양한 검사를 통해 자신의 마음 상태를 점검해 보세요.
        </p>
      </div>
      <div className="result-card">
        {resultText.map(domain => {
          const score = scores[domain.domain];
          const level = getScoreLevel(score);
          const result = domain.results.find(r => r.score === level);

          return (
            <div key={domain.domain} className="domain-result">
              <h2>{domain.title}</h2>
              <p className="short-description">{domain.shortDescription}</p>
              <div className="score-display">
                <span className="factor-name">점수</span>
                <span className="factor-score">{score}  점</span>
              </div>
              <p className="result-text">{result?.text ?? '설명 데이터가 없습니다.'}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BigFiveTestResultPage;
